import cn from 'classnames';
import React from 'react';
import { FreeTextKey } from '../../types/FreeText';
import { t } from '../../utils/i18n';
import { CardsList } from '../CardsList';
import { DH } from '../../utils/DataHook';
import { Body } from './elements';
import { EmptyView } from './elements/EmptyView';
import { FetchCardsErrorMessage } from './elements/FetchCardsErrorMessage';
import s from './styles.scss';

export interface IPageProps {
  isFetchCardsFailed: boolean;
  noCards: boolean;
  mobile: boolean;
  rtl: boolean;
  freeText: {
    [textKey: string]: string;
  };
}

export class Page extends React.Component<IPageProps> {
  renderContent() {
    if (this.props.isFetchCardsFailed) {
      return <FetchCardsErrorMessage />;
    }

    if (this.props.noCards) {
      return <EmptyView />;
    }

    return <CardsList />;
  }

  render() {
    return (
      <div
        data-hook={DH.Container}
        data-mobile={this.props.mobile}
        className={cn({
          [s.root]: true,
          [s.mobile]: this.props.mobile,
          [s.desktop]: !this.props.mobile,
          [s.rtl]: this.props.rtl,
        })}
      >
        {!this.props.mobile && (
          <section
            data-hook={DH.Header}
            className={cn(s.header, {
              [s.withBorder]: this.props.noCards || this.props.isFetchCardsFailed,
            })}
          >
            <h2 data-hook={DH.Title} className={s.title} tabIndex={0}>
              {this.props.freeText[FreeTextKey.Title] || t('wallet.title')}
            </h2>
            <div data-hook={DH.Subtitle} className={s.subtitle}>
              {this.props.freeText[FreeTextKey.Subtitle] || t('wallet.subtitle')}
            </div>
          </section>
        )}
        <Body>{this.renderContent()}</Body>
      </div>
    );
  }
}
